import React from "react";

import DragonFlyIllustration from "../../images/illustrations/Dragonfly.inline.svg";
import { Link } from "../../utils/customLink";

const TextIntro = ({
  isIllustration,
  btnLabel,
  btnTarget,
  content,
  scrollContainerClass = "h-108 md:h-80",
  innerContainerClass = "w-11/12 md:w-9/12 mx-auto py-20"
}) => {
  const {
    title,
    description,
    lastUpdated,
    showLastUpdated,
    lastUpdatedOverwrite
  } = content ?? {};

  return (
    <section
      className={`relative w-full flex justify-center overflow-hidden bg-white ${
        isIllustration ? "dark:bg-gray-darker" : "dark:bg-gray-darkest"
      }`}
    >
      {isIllustration && (
        <DragonFlyIllustration className="absolute hidden dark:block -left-[15%] -bottom-[65%]" />
      )}
      <div className={innerContainerClass}>
        <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-0 justify-between pb-7 items-start md:items-center">
          <h1
            className="!font-light"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {showLastUpdated && (
            <div
              className="h7 uppercase !font-medium dark:text-gray-generic text-black-lighter"
              dangerouslySetInnerHTML={{
                __html: lastUpdatedOverwrite ?? `last updated: ${lastUpdated}`
              }}
            />
          )}
        </div>
        <div
          className={`${scrollContainerClass} overflow-y-auto gvi-scrollbar-thin tab-content`}
        >
          <div
            className="pr-3 md:pr-11 text-black-lighter dark:text-gray-generic tab-content_html"
            dangerouslySetInnerHTML={{
              __html: description
            }}
          />
        </div>

        {btnLabel && (
          <Link
            className="block md:my-7 px-7 py-2 submit-button w-full md:w-48"
            to={btnTarget}
          >
            {btnLabel}
          </Link>
        )}
      </div>
    </section>
  );
};

export default TextIntro;
